var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 128H256V0L384 128ZM256 160H384V464C384 490.508 362.508 512 336 512H48C21.492 512 0 490.508 0 464V48C0 21.492 21.492 0 48 0H224V128C224 145.672 238.328 160 256 160ZM255.031 295.031L216 334.062V232C216 218.75 205.25 208 192 208S168 218.75 168 232V334.062L128.969 295.031C124.281 290.344 118.156 288 112 288S99.719 290.344 95.031 295.031C85.656 304.406 85.656 319.594 95.031 328.969L175.031 408.969C184.406 418.344 199.594 418.344 208.969 408.969L288.969 328.969C298.344 319.594 298.344 304.406 288.969 295.031S264.406 285.656 255.031 295.031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileArrowDown);
export default __webpack_public_path__ + "static/media/file-arrow-down.69f6669973671b7c18d1b80cfb4853c8.svg";
export { ForwardRef as ReactComponent };